import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-cream py-20 px-4" data-id="element-50">
      <div className="max-w-2xl mx-auto" data-id="element-51">
        <div className="bg-white rounded-2xl shadow-md border border-gold/30 p-8 md:p-12 text-center relative" data-id="element-52">
          <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-cream p-4 rounded-full border border-gold/20 shadow-sm" data-id="element-53">
            <ShieldCheck className="w-10 h-10 text-gold" data-id="element-54" />
          </div>

          <h2 className="text-3xl font-bold text-dark font-serif mt-6 mb-6" data-id="element-55">
            Probalo sin riesgo durante 7 días.
          </h2>

          <p className="text-lg text-dark/80 leading-relaxed mb-8" data-id="element-56">
            Si no sentís claridad o no ves avance en el proceso, te devolvemos
            el dinero. Sin preguntas. Sin formularios. Sin demoras.
          </p>

          <div className="inline-block bg-cream-dark px-4 py-2 rounded-full" data-id="element-57">
            <p className="text-sm font-bold text-olive uppercase tracking-wider" data-id="element-58">
              Garantía de satisfacción total · 7 días · 100% reembolso
            </p>
          </div>
        </div>
      </div>
    </section>;
}